<template>
  <div>
    <div class="flex-col group_11">
      <img
        class="shrink-0 self-start image_2 image_3"
        style="height: 51px;"
        :src="$images.platBg"
      />
      <div class="flex-row self-stretch relative section_10">
        <div class="flex-row items-center">
          <span class="font_7 text_17">机构名称</span>
          <div class="ml-16 flex-row items-center shrink-0 section_11">
            <el-input class="select" placeholder="请输入机构名称" v-model="jgmc"></el-input>
            <!--<el-select-->
              <!--v-model="company"-->
              <!--class="select"-->
              <!--placeholder="请选择"-->
            <!--&gt;-->
              <!--<el-option-->
                <!--v-for="item in companyOptions"-->
                <!--:key="item.value"-->
                <!--:label="item.label"-->
                <!--:value="item.value">-->
              <!--</el-option>-->
            <!--</el-select>-->
          </div>
          <span class="font_7 text_17" style="margin-left: 50px;">项目名称</span>
          <div class="ml-16 flex-row items-center shrink-0 section_11">
            <el-input class="select" placeholder="请输入项目名称" v-model="name"></el-input>
          </div>
        </div>
        <div class="flex-col justify-start items-center text-wrapper_2 ml-656" @click="search">
          <span class="font_8 text_19">搜索</span>
        </div>
      </div>
      <div class="flex-col self-stretch relative group_12">
        <el-table
          :data="tableData"
          border
          style="width: 100%">
          <el-table-column
            prop="num"
            label="序号"
            width="88"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="项目名称">
          </el-table-column>
          <el-table-column
            prop="jgmc"
            label="机构名称">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      tableData: [
        // { order: '07', projectName: 'xxx', name: 'xxxx' }
      ],
      // company: 1,
      // companyOptions: [
      //   { label: '上海添唯认证技术有限公司', value: 1 }
      // ]
      jgmc: '',
      name: ''
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.search()
    },
    async search () {
      // this.$message.success('搜索')
      const res = await this.$https.getXmsqList({
        page: 1,
        limit: 99,
        name: this.name,
        jgmc: this.jgmc
      })
      this.tableData = res.data.data.list
    }
  }
}
</script>

<style lang="less" scoped>
  .group_11 {
    .image_3 {
      margin-left: 118px;
      visibility: hidden;
    }
    .section_10 {
      margin-top: -39px;
      padding: 16px 22px 16px 40px;
      background-color: #006ed1;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .text_17 {
        color: #ffffff;
        line-height: 14px;
      }
      .section_11 {
        background-color: #ffffff;
        height: 26px;

        .select{
          width: 240px;
        }

        /deep/ .el-input__inner{
          height: 26px;
          line-height: 26px;
          border-radius: 0px;
        }

        /deep/ .el-input__icon{
          line-height: 26px;
        }

        .text_18 {
          color: #666666;
        }
        .image_4 {
          width: 8px;
          height: 5px;
        }
      }
      .text-wrapper_2 {
        padding: 8px 0;
        background-color: #004290;
        width: 68px;
        height: 26px;
        cursor: pointer;
        .text_19 {
          color: #ffffff;
          line-height: 11px;
        }
      }
    }
    .group_12 {
      margin-top: 12px;
      padding-bottom: 47px;

      /deep/ thead th{
        background: #E8F0FA;
        color: #323232;
      }
      /deep/ .el-table--border, .el-table--group {
        border: 1px solid #bebebe !important;
      }
      /deep/ .el-table--border  td,
      /deep/ .el-table--border th,
      /deep/ .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
        border-right: 1px solid #bebebe !important;
      }
      /deep/ .el-table--border th.el-table__cell {
        border-bottom: 1px solid #bebebe;
        color: #000000;
      }
      /deep/ .el-table  td, .el-table th.is-leaf  {
        border-bottom: 1px solid #bebebe!important;
      }
      .section_12 {
        padding: 14px 26px;
        background-color: #e8f0fa;
        border-left: solid 1px #bebebe;
        border-right: solid 1px #bebebe;
        border-top: solid 1px #bebebe;
        border-bottom: solid 1px #bebebe;
        .text_21 {
          margin-right: 709px;
        }
      }
      .section_18 {
        margin-top: 279px;
        padding: 18px 33px;
        background-color: #ffffff;
        border-left: solid 1px #bebebe;
        border-right: solid 1px #bebebe;
        border-top: solid 1px #bebebe;
        border-bottom: solid 1px #bebebe;
        .text_28 {
          margin-right: 662px;
        }
      }
      .section_13 {
        padding: 18px 35px;
        background-color: #ffffff;
        border-left: solid 1px #bebebe;
        border-right: solid 1px #bebebe;
        border-top: solid 1px #bebebe;
        border-bottom: solid 1px #bebebe;
        .text_22 {
          margin-right: 660px;
        }
      }
      .pos_4 {
        position: absolute;
        left: 0;
        right: 0;
        top: 44px;
      }
      .font_9 {
        font-size: 12px;
        font-family: PingFang;
        line-height: 10px;
        color: #333333;
      }
      .section_14 {
        padding: 18px 34px;
        background-color: #f6f6f6;
        border-left: solid 1px #bebebe;
        border-right: solid 1px #bebebe;
        border-top: solid 1px #bebebe;
        border-bottom: solid 1px #bebebe;
        .text_23 {
          margin-right: 661px;
          line-height: 11px;
        }
        .text_25 {
          margin-right: 649px;
        }
        .text_29 {
          line-height: 9px;
        }
        .text_30 {
          margin-right: 643px;
        }
      }
      .pos_5 {
        position: absolute;
        left: 0;
        right: 0;
        top: 91px;
      }
      .section_15 {
        padding: 16px 34px 19px;
        background-color: #ffffff;
        border-left: solid 1px #bebebe;
        border-right: solid 1px #bebebe;
        border-top: solid 1px #bebebe;
        border-bottom: solid 1px #bebebe;
        .text_24 {
          margin-right: 643px;
        }
      }
      .pos_6 {
        position: absolute;
        left: 0;
        right: 0;
        top: 138px;
      }
      .pos_7 {
        position: absolute;
        left: 0;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      .section_16 {
        padding: 19px 33px 16px;
        background-color: #ffffff;
        border-left: solid 1px #bebebe;
        border-right: solid 1px #bebebe;
        border-top: solid 1px #bebebe;
        border-bottom: solid 1px #bebebe;
        .text_26 {
          margin-right: 674px;
        }
      }
      .pos_8 {
        position: absolute;
        left: 0;
        right: 0;
        top: 232px;
      }
      .section_17 {
        padding: 16px 34px 19px;
        background-color: #f6f6f6;
        border-left: solid 1px #bebebe;
        border-right: solid 1px #bebebe;
        border-top: solid 1px #bebebe;
        border-bottom: solid 1px #bebebe;
        .text_27 {
          margin-right: 661px;
        }
      }
      .pos_9 {
        position: absolute;
        left: 0;
        right: 0;
        top: 279px;
      }
      .pos_10 {
        position: absolute;
        left: 0;
        right: 0;
        top: 372px;
      }
      .image_5 {
        width: 2px;
        height: 421px;
      }
      .pos_3 {
        position: absolute;
        left: 86px;
        bottom: 0;
      }
    }
    .font_8 {
      font-size: 12px;
      font-family: PingFang;
      line-height: 12px;
      color: #333333;
    }
  }
</style>
